export default "__VITE_ASSET__CKQ$0Gy$__"